import React from 'react';
import PropTypes from 'prop-types';

/** renders a form title */
export const FormTitle = ({ children, className }) => {
  return <h3 className={`form-title ${className || ''}`}>{children}</h3>;
};

FormTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
